// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__YGPj9","label":"SetPasswdForm_label__33tak"};